import axios from 'axios';

const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export async function reverseGeocode(lat, lng) {
  try {
    const res = await axios.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json`,
      {
        params: {
          access_token: MAPBOX_TOKEN,
          types: 'place,locality,region',
          limit: 1,
        },
      }
    );

    const feature = res.data.features?.[0];
    if (!feature) return null;

    return {
      label: feature.place_name,
      coords: {
        lat,
        lng,
      },
    };
  } catch (err) {
    console.error("Reverse geocode failed:", err);
    return null;
  }
}
